// extracted by mini-css-extract-plugin
export default {"landingLayout":"LandingPage_landingLayout__tQZ1Y","mobileHome":"LandingPage_mobileHome__9G5up","landingFooter":"LandingPage_landingFooter__DNitu"};